import React from "react";

// Inline "tuning frequency" bars — drop-in replacement for the old spinning circle.
export default function FreqLoader({ size = 16, className = "", ...rest }) {
  const cls = className.replace(/\banimate-spin\b/g, "").trim();
  const h = Number(size) || 16;
  return (
    <span role="status" aria-label="Loading" className={`dm-tuning inline-flex items-center justify-center gap-[2px] shrink-0 align-middle ${cls}`}
      style={{ height: h, width: Math.max(h, 10) }} data-testid="freq-loader" {...rest}>
      {[0, 1, 2, 3, 4].map((i) => <span key={i} className="dm-tuning-bar" style={{ animationDelay: `${i * 0.11}s` }} />)}
    </span>
  );
}
